/* Reserve only the space occupied by a visible, fixed bottom purchase bar. */
(() => {
  if (window.pwBottomBarClearance) return;
  window.pwBottomBarClearance = true;
  const root = document.documentElement;
  let frame = 0;
  let bars = [];
  const update = () => {
    frame = 0;
    const height = bars.reduce((largest, bar) => {
      const style = getComputedStyle(bar);
      if (bar.hidden || style.display === 'none' || style.visibility === 'hidden' || style.position !== 'fixed' || style.bottom === 'auto') return largest;
      const rect = bar.getBoundingClientRect();
      if (rect.top < window.innerHeight / 2) return largest;
      return Math.max(largest, rect.height);
    }, 0);
    const value = `${Math.ceil(height)}px`;
    if (root.style.getPropertyValue('--pw-bottom-bar-clearance') !== value) root.style.setProperty('--pw-bottom-bar-clearance', value);
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  const resize = new ResizeObserver(schedule);
  const attributes = new MutationObserver(schedule);
  const connect = () => {
    resize.disconnect();
    attributes.disconnect();
    bars = [...document.querySelectorAll('[data-evp-sticky], [data-final-set-bar]')];
    bars.forEach(bar => {
      resize.observe(bar);
      bar.addEventListener('transitionend', schedule);
      attributes.observe(bar, { attributes: true, attributeFilter: ['class', 'hidden', 'style', 'aria-hidden'] });
    });
    update();
  };
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', connect);
  document.addEventListener('shopify:section:unload', connect);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, { once: true });
  else connect();
})();
